<template>
  <div class="holiday_user_data">
    <h5 class="pb-3">{{ data?.user?.firstName }} {{ data?.user?.lastName }}</h5>

    <div class="left_side">
      <div class="single_line">
        <p style="float: left; width: 210px;">
          Resturlaub aus dem Vorjahr:
        </p>
        <p style="float: left; width: 30px; text-align: right">
          {{ data.lastYearDaysLeft }}
        </p>
      </div>
      <div class="clearfix"></div>

      <div class="single_line">
        <p style="float: left; width: 210px;">
          Diesjähriger Resturlaub:
        </p>
        <p style="float: left; width: 30px; text-align: right">
          {{ data.currentYearDaysLeft }}
        </p>
      </div>
      <div class="clearfix"></div>

      <div class="single_line">
        <p style="float: left; width: 210px;">
          Resturlaub nächstes Jahr
        </p>
        <p style="float: left; width: 30px; text-align: right">
          <span v-if="data.currentMonth === 12">{{ data.nextYearDaysLeft }}</span>
          <span v-else>0</span>
        </p>
      </div>
    </div>

    <div class="right_side">
      <div class="single_line">
        <p style="float: right; width: 40px; text-align: right">
          {{ data.numberOfPendingHolidays }}
        </p>
        <p style="float: right; width: 320px;">
          Ausstehende Urlaubsanträge:
        </p>
      </div>
      <div class="clearfix"></div>

      <div class="single_line">
        <p style="float: right; width: 40px; text-align: right">
          {{ data.sumOfPendingDays }}
        </p>
        <p style="float: right; width: 320px;">
          Beantragte Urlaubstage (offen):
        </p>
      </div>
      <div class="clearfix"></div>

      <div class="single_line">
        <p
            :style="{
            float: 'right',
            width: '30px',
            marginLeft: '10px',
            textAlign: 'right',
            ...parseStyle(additionalStyle)
          }"
        >
          {{ numberIfPendingApproved }}
        </p>
        <p style="float: right; width: 320px;">
          Verfügbare Urlaubstage nach Genehmigung:
        </p>
      </div>
    </div>

    <div class="clearfix"></div>

    <div style="width: 100%; border: 1px solid rgba(137, 148, 153, 0.3); margin-top: 8px; margin-bottom: 20px;"></div>

    <div class="left_side">
      <div class="single_line">
        <p style="float: left; width: 210px;">
          Gesamter Resturlaub:
        </p>
        <p style="float: left; width: 30px; text-align: right">
          {{ data.totalDaysLeft }}
        </p>
      </div>
    </div>

    <div class="right_side">
      <div class="single_line">
        <p style="float: right; width: 40px; text-align: right">
          {{ data.demandedSpecialLeaveDays }}
        </p>
        <p style="float: right; width: 320px;">
          Anzahl der beantragten Sonderurlaubstage:
        </p>
      </div>
      <div class="clearfix"></div>

      <div class="single_line">
        <p style="float: right; width: 40px; text-align: right">
          {{ data.approvedSpecialLeaveDaysInThisYear }}
        </p>
        <p style="float: right; width: 350px;">
          Genehmigte Sonderurlaubstage in diesem Jahr:
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const numberIfPendingApproved = computed(() => {
  return props.data.totalDaysLeft - props.data.sumOfPendingDays;
});

const additionalStyle = computed(() => {
  if (numberIfPendingApproved.value < 0) {
    return 'background-color: red; padding: 0 5px; color: white; border-radius: 3px;';
  } else if (numberIfPendingApproved.value === 0) {
    return 'background-color: orange; padding: 0 5px; color: white; border-radius: 3px;';
  } else {
    return 'background-color: green; padding: 0 5px; color: white; border-radius: 3px;';
  }
});

function parseStyle(styleString) {
  return styleString
      .split(";")
      .filter(style => style.trim())
      .reduce((styleObj, style) => {
        const [key, value] = style.split(":").map(s => s.trim());
        if (key && value) styleObj[key] = value;
        return styleObj;
      }, {});
}
</script>

<style scoped>

</style>